import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// UI Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

// Custom components
import { readablePhoneNumber } from "../../../utils/normalize";

export default ({ onUserAction }) => [
  {
    dataField: "description_vch",
    text: "Name",
    sort: true,
  },
  {
    dataField: "contact_vch",
    text: "Contact",
    sort: true,
    formatter: (device_vch) =>
      /^[\d]{10,11}$/.test(device_vch) ? readablePhoneNumber(device_vch) : device_vch,
  },
  {
    dataField: "channel_vch",
    text: "Channel",
    sort: true,
  },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, whitelist_record) => (
      <Fragment>
        <Link to="#" onClick={() => onUserAction("edit", whitelist_record)}>
          <FontAwesomeIcon icon={faEdit} size="lg" color="primary" className="mr-3" />
        </Link>

        <Link to="#" onClick={() => onUserAction("delete", whitelist_record)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
